import React, { useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/service/serviceTypeValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { ServiceTypeContext } from "../servicetype";

axios.defaults.baseURL = API;

function CreateServiceType(props) {

    const {dataList, setDataList, setShowData} = useContext(ServiceTypeContext);

    const handleInputPaymentTypeChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.ServiceType.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckServiceType", results[0].ServiceType);
        else
            handleChange("CheckServiceType", "");
    }

    async function saveTutorial() {
        let token = localStorage.getItem("token");
        var data = {
            ServiceType: values.ServiceType,
        }
        await axios.post("/CreateServiceType", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getAllServiceType();
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    async function getAllServiceType() {
        axios
          .get("/getAllServiceType")
          .then((response) => {
            let Data = response?.data;
            setDataList(Data);
            setShowData(Data);
          })
          .catch((error) => {
            console.log(error);
          });
      }

    const ClearData = () => 
        handleChange("ServiceType", "");

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="content">
                <div className="Header">
                    <span>ສ້າງປະເພດສິນຄ້າ</span>
                </div>
                <div className="Body">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ປະເພດສິນຄ້າ</span>
                                <input className={`input form-control ${errors.ServiceType && 'is-invalid'}`} type="text" name="ServiceType" onChange={(e) => handleInputPaymentTypeChange(e)} value={values.ServiceType || ''} required />
                                {errors.ServiceType && (
                                    <p className="invalid-feedback">{errors.ServiceType}</p>
                                )}
                            </div>
                        </div>
                        <div className="footer">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateServiceType;
